<template>
  <div v-show="showBusstopMenu && !busLocationIsOpen" class="absolute right-4 bg-white rounded border border-black px-2 py-1 w-42" :class="getTop()">
    <img src="@/assets/images/btn-close.svg" @click="closeStopName" class="btn-close">
    <div class="mt-4 mb-2">
      <div v-for="(selectedBusStop, index) in selectedBusStops" v-bind:key="index" class="mt-0.5">
        <div class="text-sm font-bold">{{ selectedBusStop.stopName }}</div>
        <div class="text-xs">({{ getCorpName(selectedBusStop.corpName) }})</div>
      </div>
    </div>
    <a class="button-primary block w-full button-is-small text-sm" @click="openStopInfo">
      バス停情報を確認
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      showBusstopMenu: false
    }
  },
  methods: {
    openStopInfo: function () {
      this.$store.dispatch('busLocation/openBusLocation')
    },
    closeStopName: function () {
      this.$store.dispatch('busLocation/close')
    },
    getCorpName: function (corpName) {
      return corpName.replace("株式会社","")
    },
    getTop: function () {
      switch (this.selectedBusStops.length) {
        case 1:
          return 'top-56'
        case 2:
          return 'top-52'
        case 3:
          return 'top-48'
        case 4:
          return 'top-44'
        case 5:
          return 'top-40'
        case 6:
          return 'top-36'
        case 7:
          return 'top-32'
        case 8:
          return 'top-28'
        default:
          return 'top-56'
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBusStops: 'busLocation/getSelectedStops',
      busLocationIsOpen: 'busLocation/getIsOpen'
    })
  },
  watch: {
    selectedBusStops: function (val) {
      if (!_.isEmpty(val)) {
        this.showBusstopMenu = true
      } else {
        this.showBusstopMenu = false
      }
    }
  }
}
</script>
